module.exports = __webpack_public_path__ + "img/trivia-995.5ad5ebc0.jpeg";